<template>
    <div class="text-center relative">
        <!-- Hero -->
        <div class="flex items-center block min-h-screen">
            <div class="container mx-auto z-20 pt-40 pb-20 text-center md:text-left px-4 relative">
                
                <div class="flex items-center space-x-2">
                    <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                    <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                </div>

                <div id="hero_text" v-html="hero_text" v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" class="bg-white inline-block p-2 rounded-lg" @mouseup="checkSelection"></div>

                <div id="hero_text" v-html="hero_text" v-else></div>
                
                <div class="flex flex-col text-center space-y-2 mt-8 md:flex-row md:space-y-0 md:space-x-4">
                    <a :href="route('empresas')" class="py-4 lg:py-6 px-4 md:px-20 bg-primary-900 hover:bg-violet-500 hover:shadow-2xl rounded-full text-white font-bold uppercase text-sm lg:text-2xl transition-all flex items-center justify-center group relative">Procuro Talento <icon name="arrow-right" class="absolute w-8 h-8 text-white right-10 opacity-0 transition-all group-hover:opacity-100 group-hover:right-8" /></a>

                    <a :href="route('ofertas')" class="py-4 lg:py-6 px-4 md:px-20 bg-primary-900 hover:bg-violet-500 hover:shadow-2xl rounded-full text-white font-bold uppercase text-sm lg:text-2xl transition-all flex items-center justify-center group relative">Procuro Emprego <icon name="arrow-right" class="absolute w-8 h-8 text-white right-10 opacity-0 transition-all group-hover:right-8 group-hover:opacity-100" /></a>
                </div>
            </div>


            <div class="absolute right-10 lg:-top-10 w-[45vw] hidden md:block">
                <div class="relative">
                    <bg-shape class="w-full opacity-20" />

                    <video class="top-10 right-2 h-full w-full object-cover grayscale brand-shape absolute opacity-70" autoplay muted id="myVideo" playsinline>
                        <source src="/videos/bg_hero_1.mp4" type="video/mp4" id="mp4Src">
                            O seu Browser não suporta video, está na altura de atualizar.
                    </video>
                </div>
            </div>
        </div>

        <div class="min-h-screen flex items-center relative bg-white" id="stamp-section">
            <div class="container mx-auto px-4 relative z-20 py-20">
                <div class="flex flex-col lg:flex-row items-center lg:space-x-12 text-center relative">
                    
                    <object data="/images/symbol.svg" type="image/svg+xml" class="relative xl:top-40 w-2/4 md:w-1/2 slideIn p-20"></object>

                   <div class="flex-1 text-center lg:text-left">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div class="bg-gray-100 inline-block text-xl lg:text-2xl lg:text-left mt-4 lg:mt-0 slide-in-right relative p-2 rounded-lg" id="home_intro" v-html="home_intro" v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText"></div>

                        <div class="flex-1 text-xl lg:text-2xl lg:text-left mt-4 lg:mt-0 slide-in-right relative" id="home_intro" v-html="home_intro" v-else></div>

                        <a :href="route('quem-somos')" class="mt-8 group text-xs text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Mais sobre nós <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></a>
                    </div>
                </div>

            </div>
        </div>

        <div class="stats bg-primary-900 relative"> 
            <div class="container mx-auto py-20 px-4 relative">
                <div class="flex flex-col space-y-10 sm:space-y-0 sm:flex-row md:space-x-20 lg:space-x-40 text-white justify-center items-center">

                    <div class="rounded-full p-10 h-52 w-52 text-center flex items-center justify-center block relative">
                        <object data="/images/shapes.svg" type="image/svg+xml" class="absolute w-52"></object>
                        <div class="relative">
                            <div class="nums colocacoes font-bold text-2xl block transition" :stats="colocacoes"></div>
                            <p class="block uppercase font-bold text-sm">Colocações</p>
                        </div>
                    </div>

                    <div class="rounded-full p-10 h-52 w-52 text-center flex items-center justify-center block relative">
                          <object data="/images/shapes.svg" type="image/svg+xml" class="absolute w-52"></object>
                        <div class="relative">
                            <div class="nums parceiros font-bold text-2xl block transition" :stats="parceiros"></div>
                            <p class="block uppercase font-bold text-sm">Parceiros</p>
                        </div>
                    </div>

                    <div class="rounded-full p-10 h-52 w-52 text-center flex items-center justify-center block relative">
                          <object data="/images/shapes.svg" type="image/svg+xml" class="absolute w-52"></object>
                        <div class="relative">
                            <div class="nums oportunidades font-bold text-2xl block transition" :stats="oportunidades"></div>
                            <p class="block uppercase font-bold text-sm">Oportunidades</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- ultimas -->
        <div class="bg-white" v-if="posts.length">
            <div class="container mx-auto px-4 py-20">
                <h3 class="py-8 uppercase font-bold text-primary-900">últimas do Blogue</h3>
                <div class="grid lg:grid-cols-3 gap-6">
                    <a v-for="post in posts" :href="route('show.post', post.slug)" class="flex-1 hover:scale-105 group transition-all rounded-lg">
                        <img :src="'/storage/posts/' + post.image" :alt="post.title" class="object-cover h-48 w-full rounded-tl-lg rounded-tr-lg grayscale group-hover:grayscale-0" />
                        <span class="w-full block text-left relative py-8">
                            <a :href="route('show.post', post.slug)"><h1 class="leading-6 text-xl font-bold text-primary-900">{{ post.title }}</h1></a>
                            <span class="text-left mt-2 leading-none text-gray-400 text-xs">
                               {{ dateFormated(post.created_at) }}
                            </span>
                            <p class="leading-relaxed my-4" v-html="post.excerto"></p>
                        </span>
                    </a>
                </div>
                <a :href="route('posts')" class="mt-8 group text-xs text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Ver Tudo <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></a>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .btn2 span:first-child{
      transform: translateX(-101%);
      transition: transform .1s ease-in
    }
    .btn2:hover span{
      transform: translateX(0)
    }
   .button {
        pointer-events: auto;
        cursor: pointer;
        background: #e7e7e7;
        border: none;
        padding: 1.5rem 3rem;
        margin: 0;
        font-family: inherit;
        font-size: inherit;
        position: relative;
        display: inline-block;
    }

.button::before,
.button::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.button--janus {
    font-weight: 900;
    width: 175px;
    height: 120px;
    color: white;
    background: none;
}

.button--janus::before {
    content: '';
    background: #3A3761;
    -webkit-clip-path: path("M154.5,88.5 C131,113.5 62.5,110 30,89.5 C-2.5,69 -3.5,42 4.5,25.5 C12.5,9 33.5,-6 85,3.5 C136.5,13 178,63.5 154.5,88.5 Z");
    clip-path: path("M154.5,88.5 C131,113.5 62.5,110 30,89.5 C-2.5,69 -3.5,42 4.5,25.5 C12.5,9 33.5,-6 85,3.5 C136.5,13 178,63.5 154.5,88.5 Z");
    transition: clip-path 0.5s cubic-bezier(0.585, 2.5, 0.645, 0.55), -webkit-clip-path 0.5s cubic-bezier(0.585, 2.5, 0.645, 0.55), background 0.5s ease;
}

.button--janus:hover::before {
    background: #8983E6;
    -webkit-clip-path: path("M143,77 C117,96 74,100.5 45.5,91.5 C17,82.5 -10.5,57 5.5,31.5 C21.5,6 79,-5.5 130.5,4 C182,13.5 169,58 143,77 Z");
    clip-path: path("M143,77 C117,96 74,100.5 45.5,91.5 C17,82.5 -10.5,57 5.5,31.5 C21.5,6 79,-5.5 130.5,4 C182,13.5 169,58 143,77 Z");
}

.button--janus::after {
    content: '';
    height: 86%;
    width: 97%;
    top: 5%;
    border-radius: 58% 42% 55% 45% / 56% 45% 55% 44%;
    border: 1px solid #8983E6;
    transform: rotate(-20deg);
    z-index: -1;
    transition: transform 0.5s cubic-bezier(0.585, 2.5, 0.645, 0.55);
}

.button--janus:hover::after {
    transform: translate3d(0,-5px,0);
}

.button--janus span {
    display: block;
    transition: transform 0.3s ease;
    mix-blend-mode: screen;
}

.button--janus:hover span {
    transform: translate3d(0,-10px,0);
}

@media screen and (min-width:  1024px) {
    .slideIn {
        animation: slideIn 1s linear infinite;
        animation-play-state: paused;
        animation-delay: calc(var(--scroll) * -1s);
        overflow-y: hidden;
        backface-visibility: hidden;
        transform-style: preserve-3d;
        transform: translate3d(0,0,0);
    }
}

@keyframes slideIn {
  to {
    transform: translateY(-400px);
  }
}
</style>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon'
    import Editor from '@tinymce/tinymce-vue'
    import BgShape from '@/Components/BgShape'

    export default defineComponent({
        components: {
            Head,
            Link,
            Icon,
            Editor,
            BgShape
        },
        layout: FrontLayout,
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            posts: Array,
            hero_text: String,
            home_intro: String,
            stats_colocacoes: String,
            stats_parceiros: String,
            stats_oportunidades: String
        },
        data(){
            return {
                colocacoes: '',
                parceiros: '',
                oportunidades: '',
                enableEdit: false,
                form: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                })
            }
        },
        mounted() {
            this.colocacoes = this.stats_colocacoes
            this.parceiros = this.stats_parceiros
            this.oportunidades = this.stats_oportunidades

            var count = 1;
            var player = document.getElementById('myVideo');
            var vidSrc = document.getElementById('mp4Src');

            player.onended = function() {
                count++;
                vidSrc.setAttribute('src', "/videos/bg_hero_"+count+".mp4");
                player.load();
                player.play();
                if(count == 2) {
                    count = 0
                }
            };
        },
        created(){
            const root = this
            window.addEventListener("scroll", function() {
                document.body.style.setProperty('--scroll', window.pageYOffset / (document.body.offsetHeight - window.innerHeight));

                // animate stats
                const e = document.querySelector('.stats') 
                const device = window.innerWidth

                if(device > 763) {
                    root.isInViewport(e) ? root.counter() : null
                } else {
                    root.counter()
                }
            }, {
                passive: true
            })
        },
        methods: {
            isInViewport(el) {
                const rect = el.getBoundingClientRect();

                return (
                    rect.top + 200 >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom - 300 <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            reset(){
                const counters = document.querySelectorAll('.nums')
              
                counters.forEach( counter => {
                    const value = +counter.getAttribute('stats');
                    counter.innerText = 0
                }); 
            },
            dateFormated(jobDate) {
                let date = new Date(jobDate)
                return date.toLocaleDateString()
            },
            counter() {
                const counters = document.querySelectorAll('.nums')
                const speed = 10000
                const device = window.innerWidth

                    counters.forEach( counter => {
                        const animate = () => {
                            let value = +counter.getAttribute('stats');
                            const data = +counter.innerText;
                            const time = value / speed;

                            if(data < value && device > 763) {
                                counter.innerText = Math.ceil(data + time);
                                setTimeout(animate, 1);
                            } else {
                                counter.innerText = value;
                            }
                        }

                        animate();
                        
                    });          

                    return

            },
            updateText(e) {
                this.form.setting = e.target.id
                this.form.content = e.target.innerHTML,
                this.form.route = this.route().current()
            },
            updateSettings(e) {
                if(this.form.setting != '' && this.form.content != '' & this.form.route != '') {
                    this.form.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.form.reset(),
                            this.$page.props.flash.success = 'Página atualizada'
                        }, 
                    })
                }
            },
        }
    })
</script>
